export default __webpack_public_path__ + "8079b6dc0c54860b8ee0fe5036059fce.png";